import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../lib/loopback'

const chatRepository = createRepository({
  path: 'chats',
  restApi,
  queryTransform: {
    ...paginate
  }
})

chatRepository.getBySolicitacaoId = (solicitacaoId, filter) => {
  return restApi.get(`chats/solicitacao/${solicitacaoId}`, { filter })
}

chatRepository.getByTarefaId = (tarefaId, filter) => {
  return restApi.get(`chats/tarefa/${tarefaId}`, { filter })
}

chatRepository.getByToken = (token, filter) => {
  return restApi.get(`chats/token/${token}`, { filter })
}

chatRepository.reanaliseByToken = token => {
  return restApi.post(`chats/token/${token}/reanalise`)
}

chatRepository.reanaliseByJWT = solicitacaoId => {
  return restApi.post(`chats/reanalise/${solicitacaoId}`)
}

export default chatRepository
